export const createCameraCanvas = (video, framed) => {
  if (!video.videoWidth || !video.videoHeight) throw new Error("Camera is not ready")
  const canvas = document.createElement("canvas")
  // Limit mobile output size without cropping to the preview container.
  const scale = framed ? Math.min(1, 1280 / Math.max(video.videoWidth, video.videoHeight)) : 1
  canvas.width = Math.max(1, Math.round(video.videoWidth * scale))
  canvas.height = Math.max(1, Math.round(video.videoHeight * scale))
  const ctx = canvas.getContext("2d")
  if (!ctx) throw new Error("Camera canvas unavailable")
  const draw = () => {
    // Keep the whole feed visible even if its orientation changes mid-recording.
    const fit = Math.min(canvas.width / video.videoWidth, canvas.height / video.videoHeight)
    const width = video.videoWidth * fit
    const height = video.videoHeight * fit
    ctx.fillStyle = "#111827"
    ctx.fillRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight,
      (canvas.width - width) / 2, (canvas.height - height) / 2, width, height)
  }
  draw()
  return { canvas, draw }
}

export const frameCameraRecording = (video, source) => {
  const { canvas, draw } = createCameraCanvas(video, true)
  // Even pixel dimensions also support mobile MP4/H.264 encoders.
  canvas.width = Math.max(2, Math.floor(canvas.width / 2) * 2)
  canvas.height = Math.max(2, Math.floor(canvas.height / 2) * 2)
  draw()
  const stream = canvas.captureStream(30)
  source.getAudioTracks().forEach((track) => stream.addTrack(track))
  let frame
  const tick = () => { draw(); frame = requestAnimationFrame(tick) }
  frame = requestAnimationFrame(tick)
  return {
    stream,
    stop: () => { cancelAnimationFrame(frame); stream.getVideoTracks().forEach((track) => track.stop()) },
  }
}
